import React, { useLayoutEffect, useState } from 'react';
import { List } from 'antd-mobile'
import { getMarketDirectory, getAreaData } from "api/api";
import { InfiniteScrollList } from 'components/InfiniteScrollList';
import { Modal } from 'antd-mobile';
// import { listModal } from 'components/ListModal';
import shopArea from "static/images/shopArea.svg";
import "static/css/shop.css";

// const fakerData = [];
// for (let i = 0; i < 10; i++) {
//   fakerData.push({
//     id: i,
//     name: `零工市场名称${i}`,
//     city: `福州市${i}`,
//     county: `鼓楼区${i}`,
//     address: `详细地址这是一段特别特别长的详细地址详细地址详细地址${i}`,
//     nature: `运营性质${i}`,
//     org: `运营机构${i}`,
//     type: `主要招聘工种这是一段特别特别长的招聘工种招聘工种招聘工种招聘工种${i}`,
//     tel: `联系电话${i}`,
//     internet: `网上平台（网址）这是一段特别特别长的网络地址${i}`,
//     startTime: `服务时间${i}`,
//     remark: `备注${i}`,
//   });
// }

/** 零工市场机构页面 */
export function MarketInquiry() {
  const [pageInfo, setPageInfo] = useState({
    totalCount: 0,
    pageIndex: 0,
    pageSize: 10,
  });
  const [list, setList] = useState([]);
  const [optionData, setOptionData] = useState(
    JSON.parse(sessionStorage.getItem('marketInquiryAreaData'))
    || []);
  const [searchName, setSearchName] = useState('');
  const [addr, setAddr] = useState('');
  const [flag, setFlag] = useState(false);
  const [hasMore, setHasMore] = useState(true)

  useLayoutEffect(() => {
    // getShopList();
    if (optionData.length === 0) {
      getOptionData();
    }
  }, [optionData]);

  /**
   * 获取机构
   * @param {*} address 地市
   * @param {*} name 搜索名称
   * @param {*} pageIndex 页码
   * @param {*} pageSize 每页大小
   */
  function getShopList(
    address = addr || '',
    name = searchName || '',
    pageIndex = pageInfo.pageIndex,
    pageSize = pageInfo.pageSize
  ) {
    setFlag(true);
    const params = {
      address,
      name,
      pageIndex,
      pageSize,
    };
    getMarketDirectory(params).then(res => {
      if (res.success) {
        const { data } = res;
        const newData = data?.marketDirectoryInfos && data.marketDirectoryInfos.map(item => ({
          id: item.id,
          name: item.marketName,
          city: item.residCity,
          county: item.residCounty,
          address: item.companyAdderss,
          nature: item.operateNature,
          org: item.operateOrg,
          type: item.mainType,
          tel: item.tel,
          internet: item.internet,
          startTime: item.startTime,
          remark: item.remark,
        }));
        setList(newData);
        setPageInfo({ pageIndex, pageSize, totalCount: data.totalCount || 0 });
      }
    }).finally(() => {
      setFlag(false);
    });
  }

  function getOptionData() {
    getAreaData(20).then(res => {
      setOptionData(res || []);
      sessionStorage.removeItem('marketInquiryAreaData');
      sessionStorage.setItem('marketInquiryAreaData', JSON.stringify(res));
    });
  }

  function handleSearch(val) {
    // 判断新值和旧值是否相等，相等则不执行
    if (val === searchName) {
      return;
    }
    setSearchName(val);
    getShopList(addr, val, 1);
  }

  function handleSelectChange(val) {
    setAddr(val);
    getShopList(val, searchName, 1);
  }

  function handlePageChange(page, pageSize) {
    getShopList(addr, searchName, page, pageSize);
  }

  // 列表上拉加载
  async function loadMore(params) {
    setPageInfo({ ...pageInfo, pageIndex: pageInfo.pageIndex + 1 })
    const newParams = {
      ...params,
      pageIndex: params.pageIndex + 1,
    };
    const { data } = await getMarketDirectory(newParams)
    const { marketDirectoryInfos } = data
    if (marketDirectoryInfos) {
      const newData = marketDirectoryInfos.map(item => ({
        id: item.id,
        name: item.marketName,
        city: item.residCity,
        county: item.residCounty,
        address: item.companyAdderss,
        nature: item.operateNature,
        org: item.operateOrg,
        type: item.mainType,
        tel: item.tel,
        internet: item.internet,
        startTime: item.startTime,
        remark: item.remark,
      }));
      setList([...list, ...newData])
      setHasMore(marketDirectoryInfos.length > 0)
    }
  }

  // 渲染列表
  function renderItem(item) {
    // const { id, name, city, county, nature, org, type, address,
    //   tel, internet, startTime, remark } = item;

    const { id, name, city, county, nature, org, type, address,
      tel, startTime, remark } = item;
    // 
    /** 模态框内数据 */
    const contentRender = (
      <div className='overlay-body'>
        {/* <div className='overlay-item'>
        <span className='overlay-item-label'>所在地市：</span>
        <span className='overlay-item-value'>{city}</span>
      </div> */}
        <div className='areaCont'>所在地市：{city}</div>
        <div className='areaCont'>所在地区/县：{county}</div>
        <div className='areaCont'>详细地址：{address}</div>
        <div className='areaCont'>运营性质：{nature}</div>
        <div className='areaCont'>运营机构：{org}</div>
        <div className='areaCont'>主要招聘工种：{type}</div>
        <div className='areaCont'>联系电话：{tel}</div>
        {/* <div className='areaCont'>网上平台（网址）{internet}</div> */}
        <div className='areaCont'>服务时间：{startTime}</div>
        <div className='areaCont'>备注：{remark}</div>
      </div>
    );
    /** 点击弹出模态框 */
    const onClick = () => {
      // listModal.show(item);
      Modal.alert({
        title: name,
        content: contentRender,
        confirmText: '我知道了',
      })
    };
    return (
      <List.Item key={name}>
        <div className='shop-item' key={id} onClick={onClick}>
          <div className="areaTitle">
            <img src={shopArea} alt='图标'></img >
            {name}
          </div>
          <div className='areaCont'>详细地址：{address}</div>
          <div className='areaCont'>联系电话：{tel}</div>
          {/* <div className='areaCont'>网上平台（网址）{internet}</div> */}
        </div>
      </List.Item>
    );
  }

  return (
    <div className='shop-service'>
      <InfiniteScrollList
        data={list}
        flag={flag}
        pageInfo={pageInfo}
        optionData={optionData}
        renderItem={renderItem}
        handleSearch={handleSearch}
        handleSelectChange={handleSelectChange}
        handlePageChange={handlePageChange}
        address={addr}
        loadMore={loadMore}
        hasMore={hasMore}
        placeholder='请输入市场名称'
        getShopList={getShopList}
      />
    </div>
  );
}
